<template>
  <b-card no-body border-variant="light" class="mb-1">
    <b-card-header
      role="tab"
      class="cursor-pointer d-flex justify-content-between align-items-center py-1"
      @click="open = !open"
    >
      <div class="d-flex align-items-center">
        <feather-icon :icon="open ? 'ChevronDownIcon' : 'ChevronRightIcon'" class="mr-50" />
        <b-badge :variant="`light-${kindVariant}`">{{ kindLabel }}</b-badge>
        <small class="text-muted ml-1">{{ section.items.length }} поз.</small>
      </div>
      <strong>{{ formatRub(section.total) }}</strong>
    </b-card-header>
    <b-collapse v-model="open">
      <b-card-body class="pt-0">
        <vue-good-table :rows="section.items" :columns="columns" :pagination-options="{ enabled: false }">
          <template slot="table-row" slot-scope="p">
            <span v-if="p.column.field === 'amount'">{{ formatRub(p.row.amount) }}</span>
            <span v-else-if="p.column.field === 'task'">
              <b-link
                v-if="p.row.planfix_task_id"
                :href="planfixTaskUrl(p.row.planfix_task_id)"
                target="_blank"
                rel="noopener"
              >
                #{{ p.row.planfix_task_id }}
              </b-link>
              <span v-else class="text-muted">—</span>
            </span>
            <span v-else-if="p.column.field === 'due_date'">
              {{ p.row.due_date || '—' }}
            </span>
            <span v-else>{{ p.formattedRow[p.column.field] }}</span>
          </template>
        </vue-good-table>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCollapse, BBadge, BLink,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import { ref, computed } from '@vue/composition-api'
import { formatRub, planfixTaskUrl } from '@/views/finance/utils'

const KIND_LABELS = { host: 'Ведущий', author: 'Автор', fixed: 'Фиксированная', extra: 'Прочее' }
const KIND_VARIANTS = { host: 'info', author: 'warning', fixed: 'secondary', extra: 'primary' }

export default {
  components: {
    BCard, BCardHeader, BCardBody, BCollapse, BBadge, BLink, VueGoodTable,
  },
  props: {
    section: { type: Object, required: true },
  },
  setup(props) {
    const open = ref(true)
    const kindLabel = computed(() => KIND_LABELS[props.section.kind] || props.section.kind)
    const kindVariant = computed(() => KIND_VARIANTS[props.section.kind] || 'secondary')

    const columns = [
      { label: 'Сумма', field: 'amount' },
      { label: 'Название', field: 'title' },
      { label: 'Дата', field: 'due_date' },
      { label: 'Задача', field: 'task' },
    ]

    return {
      open, kindLabel, kindVariant, columns, formatRub, planfixTaskUrl,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
